module.exports = __webpack_public_path__ + "4719f9e3b8ef7f1e7568407274c8628a.jpg";